import React from "react";
import {
  Col,
  Container,
  Nav,
  Row,
  Tab,
} from "react-bootstrap";
import TitleCommon from "../components/TitleCommon";
import Layout from "../Layout";
import { StyledTabs } from "../components/StyledCommon";
import FormRiskRequest from "../components/RiskClientOpportunity/FormRiskRequest";
 
const RiskClientOpportunity = () => {
  return (
    <React.Fragment>
      <Layout>
        <TitleCommon
          title={{
            text: "Crear Solicitud de Riesgos",
            icon: "plus",
          }}
          color={ "secondary" }
          button={{
            text: "Volver",
            icon: "arrow-left",
            url: "/landing",
          }}
        />
        <Container fluid style={{maxWidth:'1440px'}}>
          <Tab.Container defaultActiveKey="first" transition={false}>
            <Row className="bg-light">
              <Col>
                <StyledTabs as={Nav}>
                  <Nav.Item>
                    <Nav.Link eventKey="first">Datos generales</Nav.Link>
                  </Nav.Item>
                </StyledTabs>
              </Col>
            </Row>
            <Row>
              <Col className="pt-3 pb-5 mb-5">
                <Tab.Content>
                  <Tab.Pane
                    eventKey="first"
                    className="animate__animated animate__fadeIn"
                  >
                    <FormRiskRequest />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </Layout>
    </React.Fragment>
  );
};
 
export default RiskClientOpportunity;